// Shared brand tokens for the Leo Club of SLIIT portal.
//
// Most pages in this app use inline style objects rather than Tailwind
// classes, so a Tailwind config change alone wouldn't make them consistent.
// This module is the single place new/redesigned pages pull colors and
// common style fragments from, so "professional + on-brand" means the same
// thing everywhere instead of each page picking its own hex codes.
//
// Palette: near-black base, red as the primary interactive accent (buttons,
// active states, badges) and secondary accent (links, info), white text --
// per direction request. `gold`/`goldSoft` are kept as aliases to
// `accent`/`accentSoft` so earlier pages that already import `brand.gold`
// pick up the current color for free.

export const brand = {
  black: '#050505',
  navy: '#141414',
  navySoft: '#1c1c1c',
  panel: 'rgba(20,20,20,0.75)',
  panelSolid: '#161616',
  border: 'rgba(255,255,255,0.10)',
  borderStrong: 'rgba(255,255,255,0.16)',

  accent: '#e11d2e',
  accentSoft: 'rgba(225,29,46,0.14)',
  accentDark: '#7a0d18',
  accentDarkSoft: 'rgba(122,13,24,0.16)',
  // Back-compat aliases -- do not use in new code, prefer `accent`/`accentSoft`.
  gold: '#e11d2e',
  goldSoft: 'rgba(225,29,46,0.14)',

  blue: '#ff4757',
  blueSoft: 'rgba(255,71,87,0.16)',
  indigo: '#e11d2e',

  text: '#ffffff',
  textMuted: '#c9c9c9',
  textFaint: '#8a8a8a',

  success: '#22c55e',
  successSoft: 'rgba(34,197,94,0.14)',
  warning: '#f59e0b',
  warningSoft: 'rgba(245,158,11,0.14)',
  danger: '#ef4444',
  dangerSoft: 'rgba(239,68,68,0.14)',
};

export const shadow = {
  card: '0 10px 30px -14px rgba(0,0,0,0.55)',
  raised: '0 18px 45px -20px rgba(0,0,0,0.65)',
};

export const cardStyle = {
  background: brand.panel,
  border: `1px solid ${brand.border}`,
  borderRadius: 18,
  boxShadow: shadow.card,
};

export const pillStyle = (color, soft) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  color,
  background: soft,
  border: `1px solid ${color}33`,
});

export const primaryButtonStyle = {
  background: `linear-gradient(135deg, ${brand.indigo}, ${brand.blue})`,
  color: '#fff',
  border: 'none',
  borderRadius: 12,
  padding: '10px 18px',
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  boxShadow: '0 10px 24px -10px rgba(37,99,235,0.55)',
};

export const ghostButtonStyle = {
  background: 'rgba(255,255,255,0.06)',
  color: brand.text,
  border: `1px solid ${brand.borderStrong}`,
  borderRadius: 12,
  padding: '10px 16px',
  fontSize: 14,
  cursor: 'pointer',
};

export const inputStyle = {
  width: '100%',
  background: 'rgba(11,18,32,0.9)',
  border: `1px solid ${brand.border}`,
  borderRadius: 10,
  padding: '9px 11px',
  color: brand.text,
  outline: 'none',
  fontSize: 13.5,
};
